<div class="section">
    <cds-select layout="vertical" controlWidth="stretch">
        <label>Recurrent Neighborhood Results</label>
        <select
            name="previous-selections-selection"
            class="selections-select"
            [(ngModel)]="selectedEntry"
            (ngModelChange)="addResult()"
            [attr.aria-label]="'Select RCN data'"
        >
            <ng-container *ngFor="let rcn of rcnData$ | async">
                <option [ngValue]="rcn">{{ rcn.name }}</option>
            </ng-container>
        </select>
    </cds-select>
    <button class="wiki-btn" (click)="goToWiki()">?</button>
</div>
<div class="data-container">
    <span *ngIf="!selectedResults.size">Run the Recurrent neighborhood job to view data</span>
    <app-recurrent-neighborhoods-result-content
        *ngFor="let rcn of selectedResults"
        [rcnEntry]="rcn"
        (close)="removeResult($event)"
    ></app-recurrent-neighborhoods-result-content>
</div>
